import { updateAuthTokens } from 'common/modules/ReactShared';
import { APP_SERVER_URL, AUTH_URL } from 'students/constants';

interface IFederatedAuthData {
  type: string;
  authenticity_token: string;
  jwt_token: string;
}

function safeOrigin(url: string | undefined): string | null {
  if (!url) return null;
  try {
    return new URL(url).origin;
  } catch {
    return null;
  }
}

function getTrustedOrigins(): string[] {
  const origins = [
    window.location.origin,
    safeOrigin(AUTH_URL),
    safeOrigin(APP_SERVER_URL)
  ];
  return Array.from(new Set(origins.filter((o): o is string => Boolean(o))));
}

export function listenFederatedAuthMessage(cb?: () => void): void {
  const trustedOrigins = getTrustedOrigins();

  function listener(e: MessageEvent<IFederatedAuthData>) {
    const {
      origin,
      data: { type, authenticity_token }
    } = e;

    if (!trustedOrigins.includes(origin)) {
      return;
    }
    if (type !== 'oauth_callback') return;
    updateAuthTokens({ csrf: authenticity_token });
    cb?.();
  }
  window.addEventListener('message', listener);
}
